import { useTranslation } from 'react-i18next';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { CalendarPlanForm } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/CalendarPlanForm';
import { FundingDirectionsForm } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/FundingDirectionsForm';
import { LoanRepaymentScheduleForm } from 'components/BusinessToolForm/Sections/FinancialPlan/CashFlowElements/Sections/LoanRepaymentScheduleForm';

export const CashFlowElements: React.FC = () => {
  const { t } = useTranslation();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.FINANCIAL_PLAN,
    BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.CASH_FLOW_ELEMENTS
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.cashFlowElements.title')}
        />
      </FormSectionCard>

      <CalendarPlanForm disabled={!canAccess} />
      <LoanRepaymentScheduleForm disabled={!canAccess} />
      <FundingDirectionsForm disabled={!canAccess} />
    </>
  );
};
